import React from 'react';
import LegalLayout from '../../components/LegalLayout';

const AcceptableUse = () => (
  <LegalLayout title="MyBusinessAdPro Acceptable Use Policy (AUP)" lastUpdated="February 2026">
    <p>This Acceptable Use Policy sets out what you may and may not do when using MyBusinessAdPro. It applies alongside the <a href="/legal/terms">Terms of Service</a> and the <a href="/legal/service-agreement">Service Agreement</a>. By using the Service, you agree to comply with this AUP.</p>

    <h2>1. You MAY use MyBusinessAdPro to</h2>
    <ul>
      <li>Generate advertising content, social-media posts, images and videos for any <strong>lawful</strong> UK small or medium business — retailers, hospitality, trades, professional services, beauty, fitness, property, events, and more</li>
      <li>Promote legitimate offers, product launches, opening hours, seasonal campaigns and community events</li>
      <li>Respond to Google reviews and social-media comments with AI assistance</li>
      <li>Schedule and auto-publish content across Facebook, Instagram and Google Business Profile</li>
      <li>Run geo-targeted ad campaigns to users aged 18 and over, within your business's catchment area</li>
      <li>Export and archive your own content, leads and analytics</li>
    </ul>

    <h2>2. You MUST NOT use MyBusinessAdPro to</h2>
    <ul>
      <li>Produce or publish content that makes misleading, unverified, or prohibited claims (e.g. "cures cancer", "guaranteed results", "100% effective")</li>
      <li>Promote prescription-only medicines (POMs), pharmacy services, or other MHRA/GPhC-regulated products</li>
      <li>Promote high-risk financial products, cryptocurrency schemes, gambling, adult services, tobacco/vaping, weapons, or illegal drugs without holding the appropriate regulatory authorisation and age-gating</li>
      <li>Target advertisements to individuals under 18 on any platform</li>
      <li>Publish content that breaches the UK ASA CAP Code, CMA Green Claims Code, Equality Act 2010, or any other UK advertising regulation</li>
      <li>Upload, share or process customer-identifiable data unless you are the Data Controller and have a lawful basis</li>
      <li>Harvest user data from connected third-party platforms beyond what the platform APIs permit</li>
      <li>Attempt to circumvent the compliance checker, rate limits, or access controls</li>
      <li>Resell, sublicense, or white-label the MyBusinessAdPro service without a written partnership agreement</li>
      <li>Use the Service for any illegal purpose, including harassment, defamation, spam, phishing, deepfakes, or impersonation</li>
    </ul>

    <h2>3. AI-generated content</h2>
    <ul>
      <li>The AI Compliance Checker is an <strong>assistive tool</strong> — it does <strong>not</strong> constitute legal or regulatory sign-off.</li>
      <li><strong>You are the sole publisher</strong> of any content created with MyBusinessAdPro. You must proofread, fact-check and verify every piece of content before publishing it.</li>
      <li>If MyBusinessAdPro flags content as non-compliant or risky, you must NOT override the warning without independent verification.</li>
    </ul>

    <h2>4. Age restriction</h2>
    <p>All advertisements created through MyBusinessAdPro are strictly targeted to users aged 18 and over. Campaigns are configured at the platform level (Meta, Google) to exclude users under 18.</p>

    <h2>5. WhatsApp / SMS / email marketing</h2>
    <ul>
      <li>You may <strong>only</strong> send marketing messages to contacts who have given explicit prior consent (lawful basis: consent under UK GDPR + PECR).</li>
      <li>Every marketing message must include a one-click unsubscribe.</li>
      <li>The MyBusinessAdPro WhatsApp subscriber list operated by Krinal Ahir Ltd is the property of MyBusinessAdPro and is not transferable to individual customer accounts.</li>
    </ul>

    <h2>6. Enforcement</h2>
    <p>If we reasonably believe you have breached this AUP, we may:</p>
    <ul>
      <li>Warn you by email</li>
      <li>Suspend specific features (e.g. automatic posting)</li>
      <li>Suspend your account pending investigation</li>
      <li>Terminate your subscription with immediate effect for serious or repeated breach (per §11 of the Service Agreement)</li>
      <li>Report suspected criminal activity to the relevant authorities</li>
    </ul>

    <h2>7. Reporting abuse</h2>
    <p>To report suspected misuse of MyBusinessAdPro by another user or to raise a content-compliance concern, email <strong><a href="mailto:abuse@mybusinessadpro.co.uk">abuse@mybusinessadpro.co.uk</a></strong>.</p>

    <h2>8. Changes</h2>
    <p>We may update this AUP to reflect new product features, platform policy changes, or regulatory updates. Material changes will be notified by email and/or in-app banner.</p>

    <hr />
    <p><strong>Contact:</strong> <a href="mailto:contact@mybusinessadpro.co.uk">contact@mybusinessadpro.co.uk</a></p>
  </LegalLayout>
);
export default AcceptableUse;
